module.exports = __webpack_public_path__ + "img/partTwo-Safari.c53043b6.png";